import { collection, query, onSnapshot, where } from "firebase/firestore";
import React, { useEffect, useState } from "react";

import db from '../firebase';
import Header from "../components/Header";
import Header2 from "../components/Header2";
import StatusResult from "../components/StatusResult";


function StatusContent() {

    const [docID, setDocID] = useState("");
    const [VIN, setVIN] = useState("");
    const [Make, setMake] = useState("");
    const [details, setDetails] = useState([]);
    const [hasQuery, setHasQuery] = useState(false);




    useEffect(() => {
        const queryParameters = new URLSearchParams(window.location.search);
        if (queryParameters.get("v")) {
            setVIN(queryParameters.get("v"))
        }
        if (queryParameters.get("m")) {
            setMake(queryParameters.get("m"))
        }
        if (queryParameters.get("m") != null && queryParameters.get("v") != null) {
            setHasQuery(true);
        }
        else {
            setHasQuery(false)
        }
    }, [])

    useEffect(() => {
        if (hasQuery === true) {
            CheckStatus();
        }

    }, [hasQuery])

    async function CheckStatus() {
        const collectionRef = collection(db, 'RepairOrders');
        const q = query(collectionRef, where("VIN", "==", VIN.toUpperCase()), where("Veh_Make", "==", Make), where("Active", "==", true));

        const unsub = onSnapshot(q, (QuerySnapshot) => {
            const items = [];
            QuerySnapshot.forEach((doc) => {
                let item = doc.data();
                item.id = doc.id;
                items.push(item);
            });
            if (items.length) {
                setDetails(items[0]);
                console.log(items[0]);
            }
            else {
                alert("There was no information found for the VIN and Make entered. Please try again.")
            };
        });
        return () => {
            unsub();
        };
    }

    const vehicleMakes = [
        "Acura", "Alfa Romeo", "Aston Martin", "Audi", "Bentley", "BMW", "Buick", "Cadillac", "Chevrolet", "Chrysler", 
        "Dodge", "Ferrari", "Fiat", "Ford", "Genesis", "GMC", "Honda", "Hyundai", "Infiniti", "Jaguar", "Jeep", "Kia", 
        "Lamborghini", "Land Rover", "Lexus", "Lincoln", "Lotus", "Maserati", "Mazda", "Mercedes-Benz", "Mercury", 
        "Mini", "Mitsubishi", "Nissan", "Oldsmobile", "Pontiac", "Porche", "Rivian", "Saturn", "Subaru", "Tesla", 
        "Toyota", "Volkswagen", "Volvo"
    ];

    return (
        <div className="container" style={{ marginTop: '20px', padding: '30px' }}>
            <div className="sec-title text-left">
                <h1>Check Repair Status</h1>
            </div>
            <p>Use the form below to view a live status of your vehicle's repair..</p>
            <br />
            <div className="row">
                <div className="col-md-12">
                    <div className="contact-form">
                        <form action="#">
                            <div className="row">
                                <div className="col-md-6">
                                    <p>Enter the last 7 digits of your VIN number</p>
                                    <input className="VIN-Input" type="text" id="VIN" placeholder="VIN" maxLength="7" value={VIN} onChange={(e) => setVIN(e.target.value.toUpperCase())} />
                                </div>
                                <div className="col-md-6">
                                    <p>Select your Vehicle Make</p>
                                    <select className="Make-Input" id="country" value={Make} onChange={(e) => setMake(e.target.value)}>
                                        <option value="" disabled selected>-- SELECT MAKE --</option>
                                        {vehicleMakes.map(make => (
                                            <option key={make} value={make}>{make}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <button className="col-md-3 col-sm-12 col-xs-12 btn btn-primary btn-lg pull-right" onClick={CheckStatus}>Check</button>
                </div>
            </div>
            <div className="row">
                <StatusResult details={details} />
            </div>
        </div>
    );
}


const Status = () => {
    return (
        <>
            <Header2 />
            <StatusContent />
        </>
    )
}

export default Status